module.exports = __webpack_public_path__ + "img/undraw_tourist_map_re_293e.4ab7d76a.svg";